import moment from 'moment'
import 'moment/locale/pt-br';
   
moment.locale('pt-br');

export const percent = ( numerador, denominador,casasDecimais) =>{        
    let result = (validateNumber(numerador) / validateNumber(denominador))
    if (!isNaN(result)){
        if(result>1){
            return (100).toFixed(casasDecimais);
        }
        if(result<0){
            return (0).toFixed(casasDecimais);
        } 
        return (result*100).toFixed(casasDecimais);            
    }
    return 0;        
}  

export const calcPercent = ( numerador, denominador) =>{                
    return percent(numerador, denominador,2);        
}

export const calcPercentTrunc = ( numerador, denominador) =>{  
    return percent(numerador, denominador,0);          
}

export const validateNumber = (number) =>{
    if (number){
        return Number(number)
    }
    return 0
}

export const firebaseTimestampToMoment = (data) =>{  
    if(data?.seconds){
        return moment(data?.seconds*1000).format('DD/MM/YYYY HH:mm')
    }
    return undefined
}

//operações de busca para obter itens
export const getLocalidadePorCodigo= (localidades,ufs,codigo) =>{
    let localidade = undefined
    if(localidades){
        localidade=localidades.find(item => item.sgUe==codigo)
    }
    if(!localidade && ufs){
        localidade = ufs.find(item => item.sgUe==codigo)
    }
    return localidade
}
export const getEleicaoPorCodigo= (eleicoes,codigo) =>{
    if(eleicoes){
        return eleicoes.find(item => item.cdEleicao==codigo)
    }
    return undefined
}
export const getCargoPorCodigo= (cargos,codigo) =>{
    if(cargos){
        return cargos.find(item => item.codigo==codigo)
    }
    return undefined
}
export const getZePorNrZona= (zonasEleitorais,nrZona) =>{
    if(zonasEleitorais){
        return zonasEleitorais.find(item => item.nrZona==nrZona)
    }
    return undefined
}
export const getLocalVotaPorIdLocal= (locaisVotacao,idLocal) =>{
    if(locaisVotacao){
        return locaisVotacao.find(item => item.idLocal==idLocal)
    }
    return undefined
}

//verifica se codigo do objeto é o mesmo do objeto
export const validaCodigoLocalidade= (localidades,ufs,codigo) =>{    
    if(localidades && codigo){
        if(localidades.some(item => item.sgUe==codigo)){
            return codigo
        }
    }
    if(ufs && codigo){
        if(ufs.some(item => item.sgUe==codigo)){
            return codigo
        }       
    }
    return undefined
}
export const validaCodigoEleicao= (eleicoes,codigo) =>{
    if(eleicoes && codigo){
        if(eleicoes.some(item => item.cdEleicao==codigo)){
            return codigo
        }
    }
    return undefined
}
export const validaCodigoCargo= (cargos,codigo) =>{
    if(cargos && codigo){
        if(cargos.some(item => item.codigo==codigo)){
            return codigo
        }
    }
    return undefined
}
export const validaCodigoZe= (zonasEleitorais,nrZona) =>{
    if(zonasEleitorais && nrZona){
        if(zonasEleitorais.some(item => item.nrZona==nrZona)){
            return nrZona
        }        
    }
    return undefined
}
export const validaCodigolocalVotacao= (locaisVotacao,idLocal) =>{
    if(locaisVotacao && idLocal){
        if(locaisVotacao.some(item => item.idLocal==idLocal)){
            return idLocal
        }        
    }
    return undefined
}

//verifica se objeto é do tipo array caso contrário retorna array vazio
export const getValidArray = (object) =>{
    return Array.isArray(object)? object: []
}

//verifica se uma array tem um dado
export const arrayIncludes= (array, data) =>{
    let tmparr = Array.isArray(array)? array: []
    return tmparr.includes(data)
}

// coverte String para deixar apenas as primeiras letras em maiusculo
export function capitalizeFirstLetter(str) {

    const palavras = new String(str).split(" ");    
    for (let i = 0; i < palavras.length; i++) {        
        palavras[i] = palavras[i][0].toUpperCase() + palavras[i].toLowerCase().substr(1)
    }

    return palavras.join(" ");
}

// remove instancia da url
export function urlWithoutParams(url, urlparams) {
    let urlFinal=url    

    //Remove param
    let urlParamPos = urlFinal.indexOf('/'+urlparams)
    if(urlParamPos!=-1){
        urlFinal=urlFinal.slice(0, urlParamPos)
    }
    //Remove finalização com barra se tiver
    if(urlFinal.endsWith("/")){
        urlFinal=urlFinal.slice(0,-1)
    }

    return urlFinal;
}

